<template>
  <section class="desc-wrapper" id="qyjj">
    <div class="inner section">
      <img class="img" src="@/static/image/about-earth.png" alt="earth" />
      <div class="desc-title">
        <span class="active">{{ $t('aboutIntro.title') }}</span>
        <span> / {{ $t('aboutIntro.subTitle') }}</span>
      </div>
      <div class="desc-content">
        <p>{{ $t('aboutIntro.desc1') }}</p>
        <p>{{ $t('aboutIntro.desc2') }}</p>
      </div>
      <div class="video">
        <video src="https://ddlg-zhongtai-prd-1257088705.cos.ap-guangzhou.myqcloud.com/mp4/%E6%B9%98%E6%A5%9A%E4%BA%BA%E5%8A%9B%E5%AE%A3%E4%BC%A0%E7%89%87%EF%BC%88%E4%B8%AD%E8%8B%B1%E5%AD%97%E5%B9%95%E7%89%88%EF%BC%89.mp4" controls preload></video>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'AboutIntro' }
</script>

<style scoped lang="scss">
.desc-wrapper { width: 100%; color: #929292; }
.section { width: 1200px; margin: 0 auto; }
.inner { position: relative; }
.desc-title { margin-top: 70px; text-align: center; }
.desc-title .active { color: #1c51a3; font-size: 26px; }
.desc-content { margin-top: 24px; color: #333; text-indent: 32px; text-align: left; }
.desc-content p { line-height: 32px; margin-top: 24px; text-align: left; }
.img { position: absolute; right: 0; top: 194px; width: 316px; height: 316px; }
.video { width: 870px; height: 490px; margin: 60px auto 0; position: relative; z-index: 2; }
.video video { width: 100%; height: 100%; }
</style>
